import PropTypes from "prop-types"
import NonDrilldownObjectShape from "./NonDrilldownObjectShape"
import DrilldownObjectShape from "./DrilldownObjectShape"

const RootSeriesShape = {
  name: PropTypes.string,
  drilldownObjects: PropTypes.arrayOf(PropTypes.shape(DrilldownObjectShape)),
  nonDrilldownObjects: PropTypes.arrayOf(PropTypes.shape(NonDrilldownObjectShape)),
  count: PropTypes.number,
}

export default RootSeriesShape



// WEBPACK FOOTER //
// ./src/state/shapes/DrilldownShapes/RootSeriesShape.js